import { put, call, take, race } from 'redux-saga/effects';
import { isEmpty } from 'lodash';

import { actions as featuresActions } from '../../features';
import { api } from '../services';
import { actions as authActions } from '../../auth';

function* loadFromLocalStorage() {
  const signInToken = yield call(api.getItem, 'signInToken');
  const identificationToken = yield call(api.getItem, 'identificationToken');
  const intercomUserHash = yield call(api.getItem, 'intercomUserHash');
  const userEmail = yield call(api.getItem, 'userEmail');
  if (!isEmpty(signInToken)) {
    yield put(
      authActions.autoSignIn({
        email: userEmail,
        token: signInToken,
        intercomUserHash,
      })
    );
  }
  if (!isEmpty(identificationToken)) yield put(authActions.identifySuccess());
}

export default function* root() {
  yield put(featuresActions.featuresRequest());

  yield race({
    success: take(featuresActions.featuresSuccess),
    failure: take(featuresActions.featuresFailure),
  });

  yield call(loadFromLocalStorage);

  yield put(authActions.proceedRouting());
}
